(ns hai.ui.utils.time
  "Locale-aware formatting of save timestamps.")

(defn- same-day?
  [^js/Date a ^js/Date b]
  (and (= (.getFullYear a) (.getFullYear b))
       (= (.getMonth a) (.getMonth b))
       (= (.getDate a) (.getDate b))))

(defn format-saved-at
  "Locale-aware short label for a save timestamp. Drops the date when the save
  happened today so the steady-state line stays compact. Accepts anything with
  `.getTime` (js/Date, goog.date.DateTime) — locale formatting lives on
  js/Date, so the value is round-tripped through one."
  [t]
  (let [d (js/Date. (.getTime t))
        now (js/Date.)
        time-str (.toLocaleTimeString d js/undefined
                                      #js {:hour "numeric" :minute "2-digit"})]
    (if (same-day? d now)
      time-str
      (str (.toLocaleDateString d js/undefined
                                #js {:month "short" :day "numeric"})
           " "
           time-str))))
